import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessListRoute: InvariantJiraRoute = {
	name: 'classic-business-list',
	path: '/jira/core/projects/:projectKey/list/:navigationItemId?',
	exact: true,
};
